export default __webpack_public_path__ + "static/media/login.35df3262.png";